import React from "react";
import { useSourceId } from "./hooks";

export function RequireSource(
  props: React.PropsWithChildren<{ sourceMissing?: React.ReactNode }>,
) {
  const sourceId = useSourceId();
  return <>{sourceId ? props.children : props.sourceMissing ?? null}</>;
}
